module.exports = __webpack_public_path__ + "img/13_1.029ed87d.png";